import { z } from 'zod/mini'

import { itemShippingShape, mobilePlanShape } from './cart-item'
import { eventValue, itemObject } from './fields'
import { gtmMetadataShape } from './gtm-metadata'
import { itemShape } from './item'
import { nonEmptyString } from './non-empty-string'
import { detailedTradeInDetailsSchema } from './trade-in-details'

export const removeFromCartSchema = z.strictObject({
  ...gtmMetadataShape,
  event: z.literal('remove_from_cart'),
  has_trade_in: z.boolean(),
  ecommerce: z.strictObject({
    currency: nonEmptyString(),
    value: eventValue(),
    // The removed item only
    items: z
      .array(
        itemObject({
          ...itemShape,
          ...mobilePlanShape,
          // Not sent by the cart mapper, accepted when a caller provides them
          item_shipping_method: z.optional(
            itemShippingShape.item_shipping_method,
          ),
          item_shipping_cost: z.optional(itemShippingShape.item_shipping_cost),
        }),
      )
      .check(z.minLength(1), z.maxLength(1)),
  }),
  trade_in_details: z.optional(detailedTradeInDetailsSchema),
})
